import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Membership } from '../models';
import { NgxAimService } from '../ngx-aim.service';

@Injectable({
  providedIn: 'root'
})
export class MembershipsService {
  ngxAimService = inject(NgxAimService);
  http = inject(HttpClient);

  selectedMembership?: Membership | null;

  private baseUrl = `${this.ngxAimService.getApiUrl()}/memberships`;

  getMemberships(): Observable<Membership[]> {
    return this.http.get<Membership[]>(this.baseUrl); 
  }

  findOne(MbsPk: number): Observable<Membership> {
    return this.http.get<Membership>(`${this.baseUrl}/${MbsPk}`);
  }
}
